import store from "@redux/store";
import { BRAND_LIST, COUNTRY } from "@type/index";
import { replacePlaceholder } from "@util/helpers";

const UQHK_PRD_DOMAIN_PC = "www.uniqlo.com.hk";
const UQHK_PRD_DOMAIN_H5 = "m.uniqlo.com.hk";

export const handleCanonicalUrl = (): string => {
  const { brand_name, region } = store.getState().config;
  let origin = window.location.origin;

  if (process.env.REACT_APP_ENV === "staging") {
    origin = replacePlaceholder(origin, {
      h5: "pc"
    });
  } else if (brand_name === BRAND_LIST.UQ && region === COUNTRY.HK) {
    origin = replacePlaceholder(origin, {
      [UQHK_PRD_DOMAIN_H5]: UQHK_PRD_DOMAIN_PC
    });
  } else {
    origin = replacePlaceholder(origin, {
      "m.": "www."
    });
  }
  return origin;
};

export const handleAlternateUrl = (): string => {
  const { brand_name, region } = store.getState().config;
  let origin = window.location.origin;

  if (process.env.REACT_APP_ENV === "staging") {
    origin = replacePlaceholder(origin, {
      pc: "h5"
    });
  } else if (brand_name === BRAND_LIST.UQ && region === COUNTRY.HK) {
    origin = replacePlaceholder(origin, {
      [UQHK_PRD_DOMAIN_PC]: UQHK_PRD_DOMAIN_H5
    });
  } else {
    origin = replacePlaceholder(origin, {
      "www.": "m."
    });
  }
  return origin;
};
